import { FacilityLocation, Location, HarloweSupport, ProviderDiscount, ILocation, IMedicalBillLine, IParty, MedicalBillLine, Party, Professional } from "@harlowe/core";
import { Type } from "class-transformer";

export interface IMedicalBill
{
    id:number;
    lines:IMedicalBillLine [];
    patient: IParty | undefined;
    patientAddress: ILocation | undefined;
    phoneNumber: string;
    patientAccountNumber: string;
    gender: string;
    insuredName: string;
    insuredAddress: ILocation | undefined;
    insuredPhone: string;
    servicingProvider: FacilityLocation | undefined;
    billingProvider: FacilityLocation | undefined ;
    referringProvider: Professional | undefined;
    serviceBegin: Date;
    serviceEnd: Date;
    totalCharges: number;
    medicalBillImage?: HarloweSupport.File;
    medicalBillProviderReport?: HarloweSupport.File;
    appliedProviderDiscount?: ProviderDiscount;
    overrideDiscount: boolean;
    discountOverridePercent?: number;
    overrideMarkup: boolean;
    markupPercentOfCharges?: number;
    confirmedDiscountPercent?: number;
    calculatedDiscountPercent:number;
    servicingProviderMarkupPercent: number;
    confirmedAllowedAmount?:number;
    confirmedMarkedUpAmount?:number;
    calculatedProviderMarkupPercent: number;
    gain:number;
}


export class MedicalBill implements IMedicalBill
{
    constructor
    (
        public id:number,
        lines:MedicalBillLine [],
        public patient: Party,
        public patientAddress: Location,
        public phoneNumber: string,
        public gender: string,
        public insuredName: string,
        public insuredAddress: Location,
        public insuredPhone: string,
        public servicingProvider: FacilityLocation,
        public billingProvider: FacilityLocation,
        public referringProvider: Professional,
        public serviceBegin: Date,
        public serviceEnd: Date,
        public totalCharges: number,
        public patientAccountNumber: string
        
    )
    {
        this.lines = lines;
    }

    @Type(() => MedicalBillLine)
    lines:MedicalBillLine [];
    medicalBillImage?: HarloweSupport.File;
    medicalBillProviderReport?: HarloweSupport.File;
    appliedProviderDiscount?: ProviderDiscount;
    overrideDiscount: boolean = false;
    discountOverridePercent?: number;
    overrideMarkup: boolean = false;
    markupPercentOfCharges?: number;
    confirmedDiscountPercent?: number;
    servicingProviderMarkupPercent: number = 0;
    confirmedAllowedAmount?: number;
    confirmedMarkedUpAmount?: number;
    calculatedDiscountPercent: number = 0;
    calculatedProviderMarkupPercent: number = 1;
    gain: number = 0;
}